$('.gform_fields')
  .on('focus','input, textarea', function(){
    if( $(this).closest('form').attr('id') === 'gform_1' ){
      return;
    }
    let $parent = $(this).closest('.gfield');
    $parent.addClass('focused');
  })
  .on('blur','input, textarea', function(){
    if( $(this).closest('form').attr('id') === 'gform_1' ){
      return;
    }
    let $parent = $(this).closest('.gfield');
    if( $(this).val() ){
      // also check to make sure we're not getting back an phone input pattern
      if( $(this).val().indexOf('____') < 0 ){
        $parent.addClass('has-value');
      }
    }else{
      $parent.removeClass('has-value');
    }
    $parent.removeClass('focused');
  });


/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/
$('.ginput_container_fileupload .medium' ).each( function(){
  let $input = $(this);
  let $fakeButton = $input.closest('.gfield').find('.gfield_label');
  let btnText = $fakeButton.text();

  $input.on( 'change', function(e){
    var fileName = '';
    if( e.target.value ){
      fileName = e.target.value.split( '\\' ).pop();
    }
    if( fileName ){
      $fakeButton.text( fileName );
    } else {
      $fakeButton.html( btnText );
    }
  });
});

$(document).on('gform_post_render', function(event, form_id, current_page){
	setTimeout(function(){
		var gf_recaptchas = document.querySelectorAll('[name="g-recaptcha-response"], [name="token"]');
		// Loop through each element and add the aria-label
		gf_recaptchas.forEach(function (el) {
			el.setAttribute("aria-hidden", "true");
			el.setAttribute("aria-label", "do not use");
			el.setAttribute("aria-readonly", "true");
		});
	}, 500);// pretty janky but the response field isn't in the DOM until shortly after the form renders
});